const GADS_ID = "AW-18235258225";

// Paste Google Ads conversion labels here once created (Google Ads -> Goals -> Conversions)
const CONVERSION_LABELS = { lead: "", booking: "" };

export const fireConversion = (kind) => {
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "generate_lead", { event_category: kind });
    const label = CONVERSION_LABELS[kind];
    if (label) window.gtag("event", "conversion", { send_to: `${GADS_ID}/${label}` });
  } catch {
    /* analytics must never break the form */
  }
};
